import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { Grid } from '@mui/material'
import { Profile } from './profile/Profile'

export const TopBar = () => {
  const classes = useStyles()
  return (
    <div>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Grid container alignItems="center" spacing={3} justifyContent="space-between">
            <Grid></Grid>
            <Grid>
              <Profile />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  logo: {
    padding: '10px',
    maxHeight: '65px',
  },
  appBar: {
    background: '#cecece',
    color: '#666666',
    width: 'calc(100% - 25rem)',
    marginLeft: '25rem',
    height: '4.5rem',
  },
  icon: {
    padding: '10px',
  },
  title: {
    margin: 'logo',
  },
}))
